import Banner from '@/views/well-being/includes/Banner'
import Benetits from '@/views/well-being/includes/Benefits'
import Contact from '@/views/well-being/includes/Contact'
import Rules from '@/views/well-being/includes/Rules'
import Sliders from '@/views/well-being/includes/Sliders'

import ScrollInto from './includes/ScrollInto'

function WellBeing() {
  return (
    <>
      <ScrollInto />
      <article className="flex flex-col items-center justify-center">
        <Banner />
        <div id="benefits">
          <Benetits />
        </div>
        <Sliders />
        <div id="rules">
          <Rules />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </article>
    </>
  )
}

export default WellBeing
